import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiPatologiaInfettivaDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoPatologieInfettive({ 
              tenantId: currentTenant.Id, 
              assistitoId: assistitoId 
            });
          },
    
          byKey: (key) => {
            return api.getAssistitoPatologiaInfettivaById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                patologiaInfettivaId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoPatologiaInfettiva({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoPatologiaInfettivaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoPatologiaInfettiva({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                patologiaInfettivaId: key,
                assistitoPatologiaInfettivaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoPatologiaInfettiva({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                patologiaInfettivaId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


